<page-header [title]="titleTpl" [breadcrumb]="breadcrumbTpl" [action]="actionTpl">
  <ng-template #breadcrumbTpl>
    <nz-breadcrumb>
      @for (breadcrumb of breadcrumbs(); track breadcrumb) {
        <nz-breadcrumb-item>
          @if (breadcrumb.link) {
            <a [routerLink]="[breadcrumb.link]">{{ breadcrumb.label }}</a>
          } @else {
            {{ breadcrumb.label }}
          }
        </nz-breadcrumb-item>
      }
    </nz-breadcrumb>
  </ng-template>
  <ng-template #titleTpl> {{ pageTitle() }}</ng-template>

  <ng-template #actionTpl>
    <button type="button" *ngIf="selectedRows().length > 0" nz-tooltip="Delete" nz-button nzDanger [nzLoading]="deleting()"
            [acl]="'agent.delete'" [disabled]="selectedRows().length === 0" (click)="requestDelete.emit()">
      <i nz-icon nzType="delete"></i>
    </button>
    <button type="button" nz-button (click)="requestShowImportDrawer.emit()" [disabled]="loading()">
      <i nz-icon nzType="upload"></i>
      Upload CSV
    </button>

    @if (fieldMappingEnabled()) {
      <button type="button" nz-button nzType="primary" (click)="requestFieldMapping.emit()" [nzLoading]="loading()">Field Mapping
      </button>
    }
    <button type="button" nz-button nzType="primary" (click)="requestSaveItems.emit()" [nzLoading]="loading()">Save Items</button>
  </ng-template>
</page-header>
